import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'dateDebut';
  }
  if (serverTableData.orderBy === 'codeCommande') {
    serverTableData.orderBy = 'devisCommande.code';
  }
  if (serverTableData.orderBy === 'theme') {
    serverTableData.orderBy = 'devisCommande.theme';
  }
  if (serverTableData.orderBy === 'libelleProduit') {
    serverTableData.orderBy = 'produit.libelle';
  }
  if (serverTableData.orderBy === 'dateDebutAffichage') {
    serverTableData.orderBy = 'dateDebut';
  }
  if (serverTableData.orderBy === 'dateFinAffichage') {
    serverTableData.orderBy = 'dateFin';
  }
  if (serverTableData.orderBy === 'semaine') {
    serverTableData.orderBy = 'ligneReseau.AnneeSemaine';
  }
  return generalTransformer(serverTableData);
}
